<script>
  import { Recipient } from '@client/components/recipient';

  export let row = {};

  let photoErrors = [];

  const updateSrc = function () {
    this.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
  };

  $: domain = row.name;
</script>

<div class="name">
  {#if row.name.includes('@')}
    <Recipient recipient={row.name} history={[]} />
  {:else}
    <div class="domain">
      {#if !photoErrors.includes(domain)}
        <div class="company-logo">
          <img
            src="https://logo.clearbit.com/{domain}"
            on:error={() => (photoErrors = [...photoErrors, domain])}
            on:load={updateSrc}
            referrerpolicy="no-referrer"
            alt={domain}
            style="background: url(https://logo.clearbit.com/{domain}) no-repeat center center / contain; height: 32px; width: 32px;"
          />
        </div>
      {/if}
      {row.name}
    </div>
  {/if}
</div>

<style lang="scss">
  .name {
    :global(.recipient) {
      margin-bottom: 0;
    }

    .domain {
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .company-logo {
      background-color: var(--color-white);
      border: 1px solid var(--border-color);
      border-radius: 100%;
      padding: 2px;

      img {
        border-radius: 100%;
      }
    }
  }
</style>
